import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import { AxiosResponse } from "axios";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### chimeSDK ミーティング API 操作クラス
 */
export default class Meeting {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET StartMeeting
   */
  public async get(roomId: string, type: MeetingSessionType): Promise<StartMeetingGetModel> {
    const formatParams: any = {
      roomId,
      type
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.StargMeting, formatParams);
    const response: AxiosResponse<StartMeetingGetModel> = await this.commonService.executeSimpleGet(requestUrl, this.constructor.name, null, HitomeqErrorType.REQUEST_RETRY);
    return response.data;
  }

  /**
   * POST Meeting
   */
  public async uploadImage(roomId: string, type: MeetingSessionType, requestBody: UploadImagePostModel): Promise<StartMeetingGetModel> {
    const formatParams: any = {
      roomId,
      type
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MetingImage, formatParams);
    const response: AxiosResponse<StartMeetingGetModel> = await this.commonService.executeSimplePost(
      requestUrl,
      requestBody,
      this.constructor.name,
      null,
      HitomeqErrorType.REQUEST_RETRY
    );
    return response.data;
  }
}

export enum MeetingSessionType {
  /** オンライン面会 */
  ONLINE_RESERVATION = "ONLINE_RESERVATION",
  /** 他事業所連携 */
  OTHER_OFFICE = "OTHER_OFFICE"
}

/**
 * ### システム設定
 */
export interface StartMeetingGetModel {
  /** createMeeting のレスポンス（JSON）。接続に必要な情報 */
  meetingData: any;
  /** 接続情報 */
  attendee: any;
}

export interface UploadImagePostModel {
  /** 施設ID */
  facilityId: number;
  /** 面会ID */
  reservationId: number;
  /** 画像情報 */
  image: {
    /** 画像（base64文字列） */
    imageBase64String: string;
    /** ファイル名 */
    fileName: string;
  };
}
